module.exports = __webpack_public_path__ + "static/media/intro_png_happy-sep.60255606.png";